import React from 'react';
import styled from 'styled-components';
import { VenueTagData } from '../../../shared/dto/EntityRepository';

interface VenueTagInViewerProps {
  tag: VenueTagData;
  selectedTags: VenueTagData[];
  isEditMode: boolean;
  onToggle: (tag: VenueTagData) => void;
}

const VenueTagInViewer: React.FC<VenueTagInViewerProps> = ({
  tag,
  selectedTags,
  isEditMode,
  onToggle,
}) => {
  const isOnVenue = selectedTags.some((selected) => selected.id === tag.id);

  if (!isEditMode && !isOnVenue) return null;

  return (
    <TagItem
      $isActive={isOnVenue}
      $isEditMode={isEditMode}
      onClick={() => {
        if (isEditMode) onToggle(tag);
      }}
    >
      {tag.name}
    </TagItem>
  );
};

const TagItem = styled.div<{ $isActive: boolean; $isEditMode: boolean }>`
  width: fit-content;
  border-bottom: 1px dotted
    ${({ $isActive, theme }) => (
      $isActive ? theme.colors.color_Gray_03 : 'transparent'
    )};
  color: ${({ $isActive, theme }) => (
    $isActive ? theme.colors.color_Gray_03 : theme.colors.color_Gray_04
  )};
  opacity: ${({ $isActive }) => ($isActive ? 1 : 0.5)};
  transition: all 0.3s ease-in-out;
  cursor: ${({ $isEditMode }) => ($isEditMode ? 'pointer' : 'default')};

  &:hover {
    ${({ $isEditMode }) => ($isEditMode ? 'transform: scale(0.95);' : '')}
  }
`;

export default VenueTagInViewer;
